import { Unit } from '@retail/products/types';
import { CampaignPriceDTO } from '../dto';
import { formatPrice } from '@retail/products/utils';

interface CampaignPriceProps {
  priceWithVat: number;
  priceWithoutVat: number;
  vatFactor: number;
  currency: string;
  unit: Unit;
  locale: string;
}

export class CampaignPrice {
  priceWithVat: number;
  priceWithoutVat: number;
  vatFactor: number;
  currency: string;
  unit: Unit;
  locale: string;

  constructor(props: CampaignPriceProps) {
    this.priceWithVat = props.priceWithVat;
    this.priceWithoutVat = props.priceWithoutVat;
    this.vatFactor = props.vatFactor;
    this.currency = props.currency;
    this.unit = props.unit;
    this.locale = props.locale;
  }

  getLocaleFormattedPriceIncVat = () => {
    return formatPrice(this.priceWithVat, this.locale);
  };

  getLocaleFormattedPriceExVat = () => {
    return formatPrice(this.priceWithoutVat, this.locale);
  };

  getLocaleFormattedPrice = (incVat: boolean) => {
    return incVat ? this.getLocaleFormattedPriceIncVat() : this.getLocaleFormattedPriceExVat();
  };

  static fromDtoToList = (dto: CampaignPriceDTO, locale: string): CampaignPrice[] => {
    return dto.unitPrices.map(
      (unitPrice) =>
        new CampaignPrice({
          priceWithVat: unitPrice.priceIncVat,
          priceWithoutVat: unitPrice.priceExVat,
          vatFactor: dto.vatFactor,
          currency: dto.currency,
          unit: Unit.fromDto(unitPrice.unit),
          locale,
        })
    );
  };
}
